import styled from 'styled-components';

const StyledHeroText = styled.div`
  position: relative;
  width: 100%;
  padding-bottom: ${props => !props.textBelow ? props.theme.components_spacing_desk.large : props.theme.components_spacing_desk.xxlarge}px;
  padding-top: calc( ${props => props.theme.components_spacing_tablet.xlarge}px + 94px);
  overflow: hidden;
  .hero-text--image{
    width: 100%;
    background-size: cover;
    background-position: 50%;
    height: 70vh;
    margin: 160px 0;
    &.zero--bottom{
      margin-bottom: 0;
    }
  }
  .full--image{
    height: auto;
  }
  .full--image img{
    width: 100%;
    display: block;
  }
  .hero-text--wrap{
    position: relative;
    padding-left: 50%;
    padding-right: 64px;
  }
  .hero-text--below{
    position: relative;
    padding-left: ${ props =>  props.align === 'right' ? '64px' : '50%'};
    padding-right: ${ props =>  props.align === 'right' ? '50%' : '64px'};
  }
  .hero-text--below-landing{
    padding-right: 0;
    width: 66.66%;
  }
  .hero-text--wrap h5{
    margin-bottom: 40px;
  }
  h4.padding--bottom{
    padding-bottom: 40px
  }
  .hero-text--below h6 {
    margin-top: 80px;
    margin-bottom: 32px;
  }
  .hero-text--below p {
    color: ${ props =>  props.greyParagraph ? '#4D4D4D' : 'inherit'};
  }
  .details-wrapper {
    position: relative;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: #4D4D4D;
  }
  .detail-col{
    position: relative;
    display: flex;
    align-items: center;
    margin-right: 24px;
  }
  .detail-col img {
    margin-right: 8px;
  }
  .detail-col a {
    color: inherit;
    text-decoration: none;
  }
  .detail-col .calendar-add {
    position: absolute;
    right: -20px;
    width: 2px;
    top: 50%;
    height: 10px;
    background-color: #003D2B;
    transform: translateY(-50%);
  }
  .detail-col .calendar-add::after {
    content: '';
    position: absolute;
    width: 10px;
    height: 2px;
    top: 4px;
    left: -4px;
    background-color: #003D2B;
  }
  @media screen and (max-width: 1439px){
    .hero-text--wrap{
      padding-right: 40px;
    }
    .hero-text--below{
      padding-right: ${ props =>  props.align === 'right' ? '50%' : '64px'};
    }
    .hero-text--below-landing{
      padding-right: 0;
    }
  }
  @media screen and (max-width: 1280px) {
    .hero-text--wrap{
      padding-left: 40%;
      padding-right: 40px;
      &.hero-text--below{
        padding-left: 40px;
      }
    }

  }
  @media screen and (max-width: 1023px){
    padding-bottom: ${props => !props.textBelow ? props.theme.components_spacing_tablet.large : props.theme.components_spacing_tablet.xxlarge}px;
    padding-top: calc( ${props => props.theme.components_spacing_tablet.xlarge}px + 94px);
    .hero-text--image{
      margin: ${props => props.theme.components_spacing_tablet.xlarge}px 0;
      &.zero--bottom{
        margin-bottom: 0;
      }
    }
    .hero-text--wrap{
      padding-left: 40%;
      padding-right: 40px;
    }
    .hero-text--below{
      padding-left: ${ props =>  props.align === 'right' ? '40px' : '40%'};
      padding-right: ${ props =>  props.align === 'right' ? '40%' : '40px'};
    }
    .hero-text--below-landing{
      padding-right: 0;
    }
    .hero-text--below h6 {
      margin-top: 60px;
    }
  }
  @media screen and (max-width: 767px){
    padding-bottom: ${props => !props.textBelow ? props.theme.components_spacing_mobile.large : props.theme.components_spacing_mobile.xxlarge}px;
    padding-top: calc( ${props => props.theme.components_spacing_mobile.xlarge}px + 81px);
    .hero-text--image{
      margin: 80px 0;
      &.zero--bottom{
        margin-bottom: 0;
      }
    }
    .full--image {
      height: 40vh;
      overflow-x:hidden ;
    }
    .full--image img{
      position: relative;
      left: 50%;
      transform: translate(-50%);
      width: auto;
      height: 100%;
      display: block;
    }
    .hero-text--wrap, 
    .hero-text--below{
      padding: 0 24px;
    }
    .hero-text--below-landing{
      width: auto;
    }
    .hero-text--wrap h5{
      margin-bottom: 24px;
    }
    h4.padding--bottom{
      padding-bottom: 32px
    }
    .hero-text--below h6 {
      margin-top: 32px;
    }
  }
`;

export {
  StyledHeroText,
};

